import {IonAvatar, IonButton, IonButtons, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonLabel, IonList, IonMenuButton, IonNote, IonPage, IonRefresher, IonRefresherContent, IonRouterLink, IonRow, IonSegment, IonSegmentButton, IonSelect, IonSelectOption, IonTitle, IonToolbar, RefresherEventDetail, useIonModal, useIonRouter} from '@ionic/react';
import {capitalize, productInfo} from '../utils';
import {useStoreState} from 'pullstate';

import styles_7_6 from "./Pg_7_6.module.scss";
import {getPageData, getQuotes} from "../store/Selectors";
import React, {Fragment, useEffect, useRef, useState} from "react";
import {QuoteItem} from "../components/QuoteItem";
import {ContractItem} from "../components/ContractItem";
import {fetch_pg_1_2} from "../store/Pg_1_Store";
import {bookmark, bookmarkOutline, checkmarkOutline, chevronDownCircleOutline} from "ionicons/icons";
import {TokenStackItem} from "../components/TokenStackItem";
import {useAppUtil, useSideMenuOptions, useSideMenuUpdate} from "../components/sideMenu/SideMenuProvider";
import {tab1SideMenu} from "../components/sideMenu/PageSideMenus";
import {PageHeader} from "./PageHeader";
import {Modal} from "./Modal";
import CustomPage from "./CustomPage";
import {TokenEnwItem} from "../components/TokenEnwItem";
import {TokenEnwEntrustListItem} from "../components/TokenEnwEntrustListItem";
import {useParams} from "react-router";
import {useLoginFields} from "./Pg_A_1";
import {useFormInput, validateForm} from "../_/useForms";
import indexBy from "underscore/modules/indexBy";
import styles_TokenItem from "../components/TokenItem.module.scss";
import {handleCommonFetchErrors, navToPg_2_3, promptBrowserToLogin} from "./Utils";
import {ContractBonusItem} from "../components/ContractBonusItem";
import Ln_TokenPictureSetCoverImg from "./Ln_TokenPictureSetCoverImg";
import moment from "moment/moment";
import styles_Common from "./Common.module.scss";
import CustomField from "../components/CustomField";
import styles_Pg_C_1 from "./Pg_C_1.module.scss";
import {constCityList, constCitySubList, constStyleList} from "../_/constant";
import {push_pg_2_4} from "../store/Pg_2_Store";
import {AiItem} from "../components/AiItem";
import {Modal_3_1_WriteArticle} from "./Modal_3_1_WriteArticle";
import styles_2_1 from "./Pg_2_1.module.scss";
import {AuthStore, UserEventTestStore} from "../store/Common_Store";
import {BannerTopSwipe} from "../components/BannerTopSwipe";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {fetch_Pg_7_5, fetch_Pg_7_6, Pg_7_5_Store, Pg_7_6_Store, push_pg_7_1__savecard, push_pg_7_5} from "../store/Pg_7_Store";
import styles_ContractBonusDetailItem from "../components/ContractBonusDetailItem.module.scss";
import styles_7_5 from "./Pg_7_5.module.scss";
import {CardForPersonStatus} from "../components/CardForPersonStatus";
import QRCode from "react-qr-code";
import styles_7_2_2 from "./Pg_7_2_2.module.scss";
import styles_Pg_0_3 from "./Pg_0_3.module.scss";
import AriaModal from "../components/react-aria-modal/src/react-aria-modal";
import classNames from 'classnames';

const Pg_7_6 = (props) => {
    const pageRef = useRef();
    const pageName = "Pg_7_6";
    const pageId = "Pg_7_6";
    const {sideMenuOptions} = props;
    const setSideMenu: any = useSideMenuUpdate();
    const sideMenu: any = useSideMenuOptions();

    const router = useIonRouter();

    ///#region 會員
    const authStore = useStoreState(AuthStore, getPageData);
    const hasAuthed = authStore?.signBy ?? false;
    //const Item_會員 = hasAuthed ? authStore?.AuthData : undefined;
    ///#endregion

    useEffect(() => {
        setSideMenu({options: sideMenuOptions, side: "start", pageName: pageId});
    }, []);

    //#region Data Loading
    useEffect(() => {
        (async () => {
            let errorObj = await fetch_Pg_7_6();
            handleCommonFetchErrors(router, errorObj);
        })();
    }, []);

    let reload = async (event?: CustomEvent<RefresherEventDetail>) => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        let errorObj = await fetch_Pg_7_6();
        handleCommonFetchErrors(router, errorObj);
        event?.detail?.complete();
    }

    const pgData = useStoreState(Pg_7_6_Store, getPageData);

    useEffect(() => {
        if (pgData?.reload == true) {
            Pg_7_6_Store.replace({});
            reload();
        }
    }, [pgData]);

    const hasLoaded = pgData?.Root ?? false;

    const Item_會員積分點數 = hasLoaded ? pgData.Root.Item_會員積分點數 : undefined;
    const List_會員積分點數流水 = hasLoaded ? pgData.Root.List_會員積分點數流水 : undefined;
    const Item_會員 = hasLoaded ? pgData.Box_Header.Item_會員 : undefined;
    //#endregion

    const [errors, setErrors] = useState(false);

    //#region WarnDialog Event
    let [warnDialogActive, setWarnDialogActive] = useState<boolean>(false);
    let refWarnDialogData: any = useRef<string>(null);

    let getApplicationNode = () => {
        return document.getElementById("root");
    };

    let deactivateWarnDialogModal = (e: any = null) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        setWarnDialogActive(false);
        refWarnDialogData.current = null;
    };

    let warnDialog = (props: {
        warnType: string,
        done?: any,
        _QrCode__兌換?: any,
    }) => {
        return async (e?: any) => {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }

            refWarnDialogData.current = props;
            setWarnDialogActive(true);
        };
    };

    //#endregion

    const clickPromptForm = async () => {
        try {
            await warnDialog({
                warnType: "enterCompanyNo",
                // done: async () => {
                //
                //
                //     if (await _pushEnterPhone()) {
                //         deactivateWarnDialogModal();
                //     }
                // }
            })();
        } catch (err) {
            alert(err);
        }
    }


    //#region WarnDialog Model
    let warnDialogModal: any = null;
    if (warnDialogActive) {
        let warnDialogBody: any = null;
        let {warnType, ...moreWarnProps} = refWarnDialogData.current;

        if (warnType === "rightAnswer") {
            warnDialogBody = <Fragment>
                <div className={`warn-aboutDistance`} key={warnType}>
                    <div className={`${styles_7_2_2.popupDialog}`}>
                        <div className="warn_badge">恭喜您通過測驗！</div>
                        <div className="warn_foot">
                            <div className="buttons">
                                <div className="button_2 button" onClick={moreWarnProps.done}>查詢積分紀錄</div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>;
        }
        if (warnType === "promptQr") {
            warnDialogBody = <React.Fragment>
                <div className={`warn-enterPhone`} key={`warn-enterPhone`}>
                    <div className={`${styles_7_2_2.popupDialog}`}>

                        <IonGrid className="ion-padding">
                            <IonRow>
                                <IonCol>
                                    <h2>請出示QR碼，供店家進行兌換領取！</h2>
                                    {/*<div className={`${styles_Pg_0_3.line} ${styles_Pg_0_3.topBottomSpacing}`}></div>*/}
                                    <div className={styles_7_6.debug}>QR：{moreWarnProps._QrCode__兌換}</div>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol>
                                    <div className={styles_7_6.tc}>
                                        <QRCode
                                            size={256}
                                            style={{height: "auto", maxWidth: "80%", width: "100%"}}
                                            value={moreWarnProps._QrCode__兌換}
                                            viewBox={`0 0 256 256`}
                                        />
                                    </div>
                                </IonCol>
                            </IonRow>


                            {/*<div className="warn_badge">*/}
                            {/*    <div className="warn_form">*/}
                            {/*        <CustomField field={keyedFields.phone} errors={errors} />*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            <div className="warn_foot">
                                <div className="buttons">
                                    <IonButton tabIndex={0} onClick={deactivateWarnDialogModal}>確認</IonButton>
                                    {/*<div className="button_2 button" ></div>*/}
                                </div>
                            </div>
                        </IonGrid>
                    </div>
                </div>
            </React.Fragment>;
        }

        warnDialogModal = warnDialogBody && <Fragment>
            <AriaModal
                //includeDefaultStyles={false}
                titleText="dunno"
                onExit={deactivateWarnDialogModal}
                initialFocusElement="#WarnEnterPhoneFocus"
                getApplicationNode={getApplicationNode}
                underlayStyle={{
                    paddingTop: "44px",
                    textAlign: "center",
                    background: "inherit",
                    //top: '40px',
                    cursor: "default",
                    backgroundColor: "rgba(0,0,0,0.25)",
                    overflowY: "auto"
                }}
                verticallyCenter={true}
                dialogStyle={{
                    //borderRadius: '6px',
                    //boxShadow: '0 0 6px 0 rgb(0 65 143 / 10%)',
                    //backgroundColor: '#fff',
                    //width: "calc(100% - 16px)"
                    width: "414px"
                }}
                //focusDialog={true}
            >
                {warnDialogBody}
            </AriaModal>
        </Fragment>;
    }
    //#endregion

    return (
        <IonPage id={pageId}>
            <CustomPage name={pageId} sideMenu={false} sideMenuPosition="start" backButton={true} backButtonPath={"/tabs/7_1"}>
                <IonRefresher slot="fixed" onIonRefresh={reload}>
                    <IonRefresherContent
                        pullingIcon={chevronDownCircleOutline}
                        pullingText="Pull to refresh"
                        refreshingSpinner="circles"
                        refreshingText="Refreshing...">
                    </IonRefresherContent>
                </IonRefresher>

                {!hasLoaded && <Fragment>
                    <>
                        {/*<IonGrid className="ion-padding-start ion-padding-end extra-padding ion-padding-bottom ion-margin-bottom">*/}
                        {/*    <div>*/}
                        {/*        讀取中，讀取可能牽涉到AI計算，請稍後*/}
                        {/*    </div>*/}
                        {/*</IonGrid>*/}
                    </>
                </Fragment>}

                {hasLoaded && <Fragment>
                    <>
                        {!Item_會員 &&
                            <IonGrid>
                                <IonRow>
                                    <IonCol className="ion-justify-content-center ion-text-center w100 ion-padding">
                                        未登錄，登入後即可使用 AI生圖功能
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        }


                        <IonGrid className="ion-padding-start ion-padding-end extra-padding ion-padding-bottom ion-margin-bottom">
                            <div className={styles_7_6.cardContainerInner} onClickCapture={(ev) => {
                                if (!hasAuthed) {
                                    promptBrowserToLogin();
                                    ev.stopPropagation();
                                    return false;
                                }
                                return true;
                            }}>

                                <div className={styles_7_6.d2}>
                                    <CardForPersonStatus Item_會員積分點數={Item_會員積分點數} reload={reload}/>
                                </div>
                            </div>
                        </IonGrid>

                        <IonGrid className="ion-padding-start ion-padding-end extra-padding ion-padding-bottom ion-margin-bottom">
                            <div className={styles_7_6.cimg}>
                                <h1 className={styles_7_6.h1}>合作單位</h1>
                                <img src="https://placehold.co/363x84"/>
                            </div>
                        </IonGrid>

                        {List_會員積分點數流水.map((Item_會員積分點數流水: any, index) => {
                            return <IonGrid key={Item_會員積分點數流水.會員積分點數流水Id} className="ion-padding-start ion-padding-end extra-padding ion-padding-bottom">
                                <div className={classNames(styles_7_5.itemContainerInner, {[styles_7_5.clickable]: Item_會員積分點數流水._QrCode__兌換})} onClickCapture={(ev) => {
                                    if (!hasAuthed) {
                                        promptBrowserToLogin();
                                        ev.stopPropagation();
                                        return false;
                                    }

                                    if (Item_會員積分點數流水._QrCode__兌換) {
                                        warnDialog({
                                            warnType: 'promptQr',
                                            _QrCode__兌換: Item_會員積分點數流水._QrCode__兌換,

                                        })();
                                    }

                                    return true;
                                }}>

                                    <div className={styles_7_5.d4}>
                                        <div className="l card">
                                            <div className={styles_7_5.startContainer}>
                                                <div className={styles_7_5.titleflowContent}>
                                                    {Item_會員積分點數流水.點數異動 > 0 ? '+' : ''}{Item_會員積分點數流水.點數異動}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="r card">
                                            <article>
                                                <div className="col">
                                                    <div className="l">{Item_會員積分點數流水.事件名稱}</div>
                                                    <div className="l">{Item_會員積分點數流水.事件當時品項與規格}</div>
                                                    <div className="l">{Item_會員積分點數流水.事件動作}</div>
                                                    <div className="l">{moment(Item_會員積分點數流水.交易時間).format('YYYY/MM/DD  hh:mm A')}</div>
                                                </div>
                                            </article>

                                            {Item_會員積分點數流水._QrCode__兌換 &&
                                                <div className="c" style={{alignSelf: 'center', height: "auto", margin: "0 auto", maxWidth: 50, width: "100%"}}>
                                                    <QRCode
                                                        size={50}
                                                        style={{height: "auto", maxWidth: "100%", width: "100%"}}
                                                        value={Item_會員積分點數流水._QrCode__兌換}
                                                        viewBox={`0 0 256 256`}
                                                    />
                                                </div>
                                            }
                                        </div>

                                    </div>
                                </div>
                            </IonGrid>
                        })}
                    </>
                </Fragment>
                }
                {warnDialogModal}
            </CustomPage>
        </IonPage>
    )
};

export default Pg_7_6;
